import React from 'react'
import styled from 'styled-components'
import Wave from './Wave';

const SectionGroup = styled.div`
    background: url(${props => props.image});
    /* background-position: -0.5vw 80%; */
    /*background-position: -75px 80%;*/
    background-position: -185px 80%;
    /* background-position: bottom; */
    height: 1000px;
    background-size: cover;
    display: grid;
    grid-template-rows: 300px auto;
    grid-gap: 20px;
    position: relative;
    /* Additional */
    margin: 100px 0 0;
    padding: 150px 0 150px;    
    justify-items: center;
    @media (max-width: 640px) {
        /*height: 820px;*/
        /*height: 1970px;*/
        height: 1770px;
        background-position: 21% 50%;
        margin: 0;
        padding: 0 0 50px;
    }
       @media (min-width: 640px) and (max-width: 1124px) {
         /* max-width: 640px */
        /*height: 820px;*/
        height: 130vh;
        background-position: 21% 50%;
    }

          @media (min-width: 800px) and (max-width: 1124px) and (orientation:landscape) {
              height: 145vh;

    }
          @media (min-width: 1124px) and (max-width: 1300px) {
              height: 190vh;
              margin-top: -100px;
              margin-bottom: -50px;

    }

`

const SectionLogo = styled.img`
    align-self: end;
    width: 128px;
    margin: 0 auto;
`

const SectionTitleGroup = styled.div`
    display: grid;
    grid-template-columns: 300px auto;
    /* grid-template-columns: repeat(2, 1fr); */
    margin: 0 40px;
    /* grid-gap: 20px; */
    grid-gap: 8rem;
    grid-template-rows: auto 100%;
    /* Additional */
    max-width: 60vw;
    align-items: start;
    @media (max-width: 720px) {
        grid-template-columns: 1fr;
    }
     @media (min-width: 640px) and (max-width: 1124px) {
        display: inline-block;
    }
`

const SectionTitle = styled.h3`
    color: #252a2b;
    font-size: 54px;
    margin: 0;
    line-height: 1.2;
    @media (max-width: 720px) {
        font-size: 40px;
    }
`

const SectionText = styled.div`
    color: #F2F2F7;
    mix-blend-mode: exclusion;
    /* color: #252a2b; */
    line-height: 1.5; 
`

const SectionLink = styled.div`
    display: grid;
    grid-template-rows: 40px 1rem;
    margin: -150px auto 0;
    /* margin: -150px auto 0; */
    position: relative;
    /* Additional */
    justify-items: center;
     @media (max-width: 640px) {
        margin: 0;
    }
    @media (min-width: 800px) and (max-width: 1124px) and (orientation:landscape) {
        margin-top: -50px;
    }
    `

const WaveBottom = styled.div`
    position: absolute;
    width: 100%;
    bottom: -8px;
       @media (max-width: 640px) {
svg {
    height: 50px!important;
  }
}
`

const WaveTop = styled.div`
    position: absolute;
    width: 100%;
    top: -8px;
    transform: rotate(180deg);
       @media (max-width: 640px) {
svg {
    height: 50px!important;
  }
}
`

const Section = props => (
    <SectionGroup image={props.image}>
        <WaveTop><Wave /></WaveTop>
        <WaveBottom><Wave /></WaveBottom>
        <SectionLogo src={props.logo} />
        <SectionTitleGroup>
            <SectionTitle>{props.title}</SectionTitle>
            <SectionText>
                <div>Preparing for examination, Linglab provides students with the materials corresponding to the required certification level and the multiple tests to provide a set of measures of functional proficiency in Russian language and assists in explaining difficulties or reinforcing language skills.</div>
                <div>The reading comprehension section consists of short texts followed by several questions translated into English and some writing tasks, all of which are aimed to assist in memorizing the language pattern and grammatical units.</div>
                <div>To improve listening skills, Linglab uses materials based on authentic speech samples, and through speaking, encourages the students to interpret their communication style into the foreigner language.</div>
            </SectionText>
            {/* <SectionLink>{props.link} <a href="https://linglab.eu/contact-us" className="active"></a></SectionLink> */}
            {/* <Link to="/" activeClassName="link__active">Learn More</Link> */}
        </SectionTitleGroup>
        <SectionLink><a href="/#Contact" className="CoursesLinks">Learn more</a></SectionLink>
    </SectionGroup>
)

export default Section